(function($) {
    $.fn.incrementSelect = function() {
        return this.each(function() {
            const $select = $(this);

            const min = parseInt($select.attr('min')) || 0;
            const max = parseInt($select.attr('max')) || 10;
            const prepend = $select.attr('prepend') || '';
            const defaultVal = parseInt($select.attr('default')) || min;
            // Clear and populate <option> tags
            $select.empty();
            $select.addClass('text-center');
            for (let i = min; i <= max; i++) {
                let label = prepend ? `${i} ${prepend}${i > 1 ? 's' : ''}` : i;
                let selectedAttr = (i === defaultVal) ? ' selected' : '';
                $select.append(`<option value="${i}"${selectedAttr}>${label}</option>`);
            }

            // Add form-control class for Bootstrap
            $select.addClass('form-control');

            // Create input group elements
            const $wrapper = $('<div class="input-group custom-select-stepper mb-3 w-auto"></div>');
            const $decBtn = $(`
                <div class="input-group-prepend">
                    <button class="btn btn-outline-secondary" type="button">
                        <i class="fa fa-minus"></i>
                    </button>
                </div>`);
            const $incBtn = $(`
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>`);

            // Wrap and insert
            $select.wrap($wrapper);
            $select.before($decBtn);
            $select.after($incBtn);

            // Button events
            $decBtn.find('button').on('click', function() {
                let val = parseInt($select.val());
                if (val > min) $select.val(val - 1).trigger('change');
            });

            $incBtn.find('button').on('click', function() {
                let val = parseInt($select.val());
                if (val < max) $select.val(val + 1).trigger('change');
            });
        });
    };
})(jQuery);
